/**
 * Utility to extract error message from API responses
 * Handles both FastAPI (detail) and NestJS (message) error formats
 */
export const getErrorMessage = (error) => {
  if (!error?.response?.data) {
    return error?.message || 'An error occurred';
  }

  const errorData = error.response.data;
  
  // NestJS format: { message: "...", error: "...", statusCode: ... }
  if (errorData.message) {
    return errorData.message;
  }
  
  // FastAPI format: { detail: "..." }
  if (errorData.detail) {
    return errorData.detail;
  }
  
  // Fallback to error string or default
  return typeof errorData === 'string' ? errorData : 'An error occurred';
};

